export default __webpack_public_path__ + "static/media/gallery_00.14b9cee7.jpg";